import * as React from 'react';

function XIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" {...props}>
			<g clipPath="url(#prefix__clip0_25812_246658)">
				<mask
					id="prefix__a"
					style={{
						maskType: 'luminance',
					}}
					maskUnits="userSpaceOnUse"
					x={0}
					y={0}
					width={24}
					height={24}
				>
					<path d="M0 0h24v24H0V0z" fill="currentColor" />
				</mask>
				<g mask="url(#prefix__a)">
					<path
						d="M18.9 1.125h3.68l-8.04 9.213L24 22.876h-7.406l-5.804-7.603-6.635 7.603H.471l8.6-9.857L0 1.127h7.594l5.24 6.948 6.066-6.95zm-1.294 19.543h2.04L6.48 3.218H4.293l13.313 17.45z"
						fill="currentColor"
						fillOpacity={0.9}
					/>
				</g>
			</g>
			<defs>
				<clipPath id="prefix__clip0_25812_246658">
					<path fill="currentColor" d="M0 0h24v24H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default XIcon;
